import { type FC } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface IProps {
  text?: string;
  className?: string;
}

const Divider: FC<IProps> = ({ text, className = "border-border-3" }) => {
  return (
    <div className="flex flex-row items-center gap-2.5">
      <div className={cn("w-full border-b border-border-3", className)} />
      { text && (
        <>
          <span className="text-[10px]/[16px] font-medium uppercase tracking-[1px] text-text-tertiary">{text}</span>
          <div className={cn("w-full border-b border-border-3", className)} />
        </>
      ) }
    </div>
  );
};

export default Divider;
